<template>
    <div class="wrapper" v-loading="isLoading">
        <div class="chura-logo-wrapper">
            <a href="https://chura-venture.com" class="hyperlink">
                <img src="@/assets/images/chura_venture_logo.png">
                <span>サイトに戻る</span>
            </a>
        </div>
        <div class="clearfix">
            <Facility v-for="facility in facilityData"
                      :facility-code="facility.code"
                      :image-url='facility.imageUrl'
                      :description="facility.description"
                      :enable="facility.enable"
                      @click="chooseFacility($event)"/>
        </div>

        <el-row style="width: 95%; margin-top: 20px; margin-left: 2%; margin-right: 2%">
            <h2>{{$t('homePage.notificationTitle')}}</h2>
        </el-row>

        <el-row style="width: 95%; margin-left: 2%; margin-right: 2%; border: 1px solid red; min-height: 100px">
            <div class="rule-wrapper">
                <div style="padding: 0 10px;" v-html="rules"></div>
            </div>
            <div class="file-wrapper" v-if="rulesFileName">
                <el-row style="padding-top: 10px; padding-right: 10px">
                    <label style="color: red">{{$t('homePage.downloadAttachFileTitle')}}</label>
                </el-row>

                <el-row style="padding-top: 10px; padding-right: 10px; margin-bottom: 20px;">
                    <el-link style="color: #3C78D8;" @click="downloadAttachFile">{{rulesFileName}}
                    </el-link>
                </el-row>

            </div>
        </el-row>
    </div>

</template>

<script>
    import Facility from "./components/Facility";
    import TextEditor from "../../components/TextEditor";
    import RuleApi from "../../api/rule/RuleApi";
    import Pages from '@/router/Pages';

    export default {
        name: "Home",
        components: {TextEditor, Facility},
        data() {
            return {
                facilityData: [{
                    code: "bc264bd4-cd11-4f66-90f6-c7b4e4d8ce29",
                    imageUrl: "https://okinawa-booking-dev.s3-ap-northeast-1.amazonaws.com/chura.png",
                    enable: true,
                    description: "沖縄県最大級の海上アスレチック「ちゅらウォーターパーク」のご予約はこちらから<br><br>" +
                        "大人(15歳以上)：1,500円<br>" +
                        "子供(14歳以下)：1,000円<br>" +
                        "幼児(5歳以下)：500円<br>"
                }, {
                    code: "c4e02550-9f07-4d95-b258-d88121873584",
                    imageUrl: "https://okinawa-booking-dev.s3-ap-northeast-1.amazonaws.com/net_park.png",
                    enable: true,
                    description: "沖縄県初の3階建てネットアスレチック「ちゅらネットパーク」のご予約はこちらから<br><br>" +
                        "大人(15歳以上)：1,500円<br>" +
                        "子供(14歳以下)：1,000円<br>" +
                        "幼児(5歳以下)：500円<br>"
                }],
                choose: false,
                rules: null,
                isLoading: false,
                rulesFileName: null,
            }
        },

        created() {
            RuleApi.getRulesForSelectFacilityDisplay().then(result => {
                this.rules = result.rules;
                this.rulesFileName = result.fileName;
            });
            this.showFooter();
        },
        beforeRouteLeave(to, from, next) {
            this.hideFooter();
            next();
        },
        mounted() {
            const code = this.$route.query.code;
            let found = false;
            for (let i = 0; i < this.facilityData.length; i++) {
                if (this.facilityData[i].code === code) {
                    this.chooseFacility(this.facilityData[i]);
                    found = true;
                    break;
                }
            }
            if (!found) {
                this.clearUrlParam();
            }
        },
        methods: {
            showFooter() {
                this.$emit("show-footer");
            },
            hideFooter() {
                this.$emit("hide-footer");
            },
            clearUrlParam() {
                window.history.pushState({}, "", window.location.pathname);
            },
            chooseFacility({code, imageUrl}) {
                this.$router.push({path: Pages.bookingCalendar.path, query: {facilityCode: code}})
            },
            back() {
                this.choose = false;
                this.showFooter();
                this.clearUrlParam();
            },

            downloadAttachFile() {
                let vm = this;
                vm.isLoading = true;
                RuleApi.downloadAttachFile().then(blob => {
                    vm.isLoading = false;
                    let downloadLink = window.document.createElement('a');
                    downloadLink.href = window.URL.createObjectURL(new Blob([blob], {type: blob.type}));
                    downloadLink.download = this.rulesFileName;
                    console.log(blob.type)
                    document.body.appendChild(downloadLink);
                    downloadLink.click();
                    document.body.removeChild(downloadLink);
                });
            }
        },
    }
</script>

<style scoped lang="scss">

    .chura-logo-wrapper {
        display: flex;
        justify-content: flex-start;
        align-items: center;
        width: 300px;
        margin-left: -6%;
        margin-bottom: 60px;

        img {
            width: 125px;
            margin-right: 20px;
        }

        .hyperlink {
            color: #3b3b3b;

            &:hover {
                color: black;
            }

            span {
                position: relative;
                bottom: 13px;
                font-size: 20px;
                font-weight: bold;
            }
        }
    }


    @media screen and (max-width: 1100px) {
        .wrapper {
            width: 100% !important;
            margin: 20px 0 !important;
        }

        .chura-logo-wrapper {
            margin-left: 0px;
        }
    }

    @media screen and (max-width: 600px) {
        .rule-wrapper {
            width: 100% !important;
        }
        .file-wrapper {
            width: 100% !important;
            text-align: left !important;
            padding: 0 0 10px 10px;
            float: left !important;
        }

        .wrapper {
            margin: 0 !important;
        }

        .chura-logo-wrapper {
            width: 100%;
            justify-content: center;
        }
    }

    .rule-wrapper {
        float: left;
    }

    .file-wrapper {
        float: right;
        text-align: right;
    }

    .wrapper {
        width: 86%;
        margin: 20px 8%;
    }

    .text-editor {
        div.tox tox-tinymce {
            border: none !important;
        }

        .tox-statusbar {
            border: none !important;
        }

        .tox-tinymce {
            border: none !important;
        }

    }


</style>